<template>
  <div class="wrap">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      navId: '0',
    };
  },
  computed: mapState({
    listId: state => state.app.listId,
    menuOpenId: state => state.app.menuOpenId,
    columns: state => state.app.columns,
  }),
  watch: {
    $route() {
      this.getClass();
    },
  },
  created() {
    this.getClass();
  },
  methods: {
    getClass() {
      const {
        params: {
          question,
        },
      } = this.$route;
      let obj = {};
      const forEach = (data) => {
        data.forEach((item) => { // question.indexOf(item.name) !== -1
          if (item.name === question) {
            obj = item;
          } else if (item.children && item.children.length) {
            forEach(item.children);
          }
        });
      };
      forEach(this.columns);
      function getPathByKey(value, key, arr) {
        const temppath = [];
        try {
          // eslint-disable-next-line
            function getNodePath(node) {
            // 这里可以自定义push的内容，而不是整个node,而且这里node也包含了children
            temppath.push(node);
            // 找到符合条件的节点，通过throw终止掉递归
            if (node[key] === value) {
              // eslint-disable-next-line
                throw ('GOT IT!');
            }
            if (node.children && node.children.length > 0) {
              for (let i = 0; i < node.children.length; i += 1) {
                getNodePath(node.children[i]);
              }
              // 当前节点的子节点遍历完依旧没找到，则删除路径中的该节点
              temppath.pop();
            } else {
              // 找到叶子节点时，删除路径当中的该叶子节点
              temppath.pop();
            }
          }
          for (let i = 0; i < arr.length; i += 1) {
            getNodePath(arr[i]);
          }
        } catch (e) {
          return temppath;
        }
        return null;
      }
      if (obj.id) {
        const { id } = obj;
        // const { name } = obj;
        const newList = getPathByKey(id, 'id', this.columns);
        this.navId = newList[0].id;
        // this.$router.push(`/${this.navId}/list/${id}?name=${name}&page=1`);
      }
    },
  },
};
</script>
